/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manageyourthemeandlanguagepreferences5Inputs */

const en_manageyourthemeandlanguagepreferences5 = /** @type {(inputs: Manageyourthemeandlanguagepreferences5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your theme and language preferences`)
};

const de_manageyourthemeandlanguagepreferences5 = /** @type {(inputs: Manageyourthemeandlanguagepreferences5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design und Sprache verwalten`)
};

/**
* | output |
* | --- |
* | "Manage your theme and language preferences" |
*
* @param {Manageyourthemeandlanguagepreferences5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const manageyourthemeandlanguagepreferences5 = /** @type {((inputs?: Manageyourthemeandlanguagepreferences5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manageyourthemeandlanguagepreferences5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manageyourthemeandlanguagepreferences5(inputs)
	return de_manageyourthemeandlanguagepreferences5(inputs)
});
export { manageyourthemeandlanguagepreferences5 as "manageYourThemeAndLanguagePreferences" }